module.exports = __webpack_public_path__ + "static/media/family-suite-img1.2ee622ec.jpg";